import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { UserRegNewWithMobApi } from "../../ApiServices/My Profile/MyProfileApi";
import DatePicker from "react-date-picker";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { ERROR_MESSAGES } from "../GlobalErrorMessage";
import { GetProfileDetails, GetUserModel, UpdateProfile } from "../../ApiServices/Profile/ProfileApi";
import toast from "react-hot-toast";
import { customSelectStyles } from "../../middlewares/Utils";
import Breadcrumbs from "../Breadcrumb";
import { t } from "i18next";
import { LoaderContext } from "../../AuthContext/AuthContext";
import ErrorMassagePupUp from "../ErrorMassagePupUp";
import { UploadImage } from "../../ApiServices/UploadImage/UploadImageApi";


const MyProfile = () => {
  const userKeyID = localStorage.getItem("userKeyID");
  const [error, setError] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const { setLoader, selectedLanguageID, formatToIndianCurrency, isLanguageUpdate } = useContext(LoaderContext);

  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();

  const ItemAddedToast = () => toast.success("Profile Updated successfully");

  const location = useLocation();
  const eighteenYearsAgo = new Date();
  eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);

  const [filePreview, setFilePreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [sizeError, setSizeError] = useState('');
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const birthSigns = [
    { value: 1, label: t("Aries") },
    { value: 2, label: t("Taurus") },
    { value: 3, label: t("Gemini") },
    { value: 4, label: t("Cancer") },
    { value: 5, label: t("Leo") },
    { value: 6, label: t("Virgo") },
    { value: 7, label: t("Libra") },
    { value: 8, label: t("Scorpio") },
    { value: 9, label: t("Sagittarius") },
    { value: 10, label: t("Capricorn") },
    { value: 11, label: t("Aquarius") },
    { value: 12, label: t("Pisces") },
  ];
  const [agreementObj, setAgreementObj] = useState({
    DOB: null,
    BIRTH_PLACE: null,
    BIRTH_TIME: null,
    GENDER: null,
    USER_NAME: null,
    ADDRESS: null,
    ZODIAC_SIGN: null,
    MOBILE_NUMBER: null,
    email: null
  });

  useEffect(() => {
    GetProfileDetailsData();
  }, [selectedLanguageID]);

  const GetProfileDetailsData = async () => {
    setLoader(true);

    try {
      const response = await GetProfileDetails(userKeyID);
      if (response?.statusCode === 200) {
        setLoader(false);
        const ModelData = response?.responseData?.data || []; // Assuming the data is an array and we need the first item

        setAgreementObj((prev) => ({
          ...prev,
          DOB: ModelData?.dob,
          BIRTH_PLACE: ModelData?.birthPlace,
          BIRTH_TIME: ModelData?.tob,
          GENDER: ModelData?.genderID,
          USER_NAME: ModelData?.userName,
          ADDRESS: ModelData?.address,
          ZODIAC_SIGN: Number(ModelData?.zodiacSignID),
          MOBILE_NUMBER: ModelData?.mobileNo,
          email: ModelData?.email,

        }));
        setFilePreview(ModelData?.profilePhoto)
        setSelectedFile(ModelData?.profilePhoto)
        setUploadedImageUrl(ModelData?.profilePhoto)
      } else {
        setLoader(false);
        setShowErrorModal(true)
        setErrorMessage(response?.response?.data?.errorMessage)

      }
    } catch (error) {
      setLoader(false);
      setShowErrorModal(true)
      setErrorMessage(error?.message)

    }
  };

  const AddUpdateCustomerBtnClick = () => {
    let isValid = false;

    if (
      agreementObj.DOB === null ||
      agreementObj.DOB === undefined ||
      agreementObj.DOB === "" ||
      agreementObj.BIRTH_PLACE === null ||
      agreementObj.BIRTH_PLACE === undefined ||
      agreementObj.BIRTH_PLACE === "" ||
      agreementObj.BIRTH_TIME === "" ||
      agreementObj.BIRTH_TIME === null ||
      agreementObj.BIRTH_TIME === undefined ||
      agreementObj.GENDER === "" ||
      agreementObj.GENDER === null ||
      agreementObj.GENDER === undefined ||
      agreementObj.USER_NAME === "" ||
      agreementObj.USER_NAME === null ||
      agreementObj.USER_NAME === undefined ||
      agreementObj.ADDRESS === null ||
      agreementObj.ADDRESS === undefined ||
      agreementObj.ADDRESS === "" ||
      agreementObj.ZODIAC_SIGN === null ||
      agreementObj.ZODIAC_SIGN === undefined ||
      agreementObj.ZODIAC_SIGN === "" ||
      agreementObj.email === null ||
      agreementObj.email === undefined ||
      agreementObj.email === "" ||
      agreementObj.MOBILE_NUMBER === null ||
      agreementObj.MOBILE_NUMBER === undefined ||
      agreementObj.MOBILE_NUMBER === "" ||
      agreementObj.MOBILE_NUMBER?.length < 10
    ) {
      setError(true);
      isValid = true;
    } else if ((agreementObj.email !== null && agreementObj.email !== undefined && agreementObj.email !== "") && !validateEmail(agreementObj.email)) {
      setError(true);
      isValid = true;
    }
    const apiParam = {
      userKeyID: userKeyID,
      dob: agreementObj.DOB,
      birthPlace: agreementObj.BIRTH_PLACE,
      tob: agreementObj.BIRTH_TIME,
      genderID: agreementObj.GENDER,
      userName: agreementObj.USER_NAME,
      address: agreementObj.ADDRESS,
      zodiacSignID: agreementObj.ZODIAC_SIGN,
      mobileNo: agreementObj.MOBILE_NUMBER,
      email: agreementObj?.email,
      profilePhoto: uploadedImageUrl
    };
    // return isValid;
    if (!isValid) {
      UpdateProfileData(apiParam);
    }
  };

  const UpdateProfileData = async (apiParam) => {
    setLoader(true)
    try {
      const response = await UpdateProfile(apiParam);
      if (response?.statusCode === 200) {
        setLoader(false)
        ItemAddedToast();
        if (location?.state?.modelName === "Horoscope") {
          navigate("/basic-details");
        } else {
          navigate("/");
        }
      } else {
        setLoader(false)
        setErrorMessage(response?.response?.data?.errorMessage);
        setShowErrorModal(true)

      }

    } catch (error) {
      setLoader(false)
      setShowErrorModal(true)
      setErrorMessage(error?.message).error(error);
    }
  };

  const handleApiCall = async (file) => {
    setLoader(true);
    const formData = new FormData();
    formData.append("File", file);

    try {
      const response = await UploadImage(formData);
      if (response?.url) {
        const uploadedUrl = response?.url;
        setUploadedImageUrl(uploadedUrl);
        console.log("Uploaded Image URL:", uploadedUrl);
      } else {
        console.warn("Upload succeeded but no URL found:", response?.data);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleDateChange = (date) => {
    setAgreementObj((prevState) => ({
      ...prevState,
      DOB: date, // Update state with selected date
    }));
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleImageChange = (e) => {

    const file = e.target.files[0];
    if (!file) return;

    // Allowed types
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      setSizeError("Only JPG, JPEG, PNG files are allowed.");
      return;
    }

    // Size check (10 MB)
    if (file.size > 10 * 1024 * 1024) {
      setSizeError("File size must be less than 10 MB.");
      return;
    }

    setSizeError("");
    setSelectedFile(file);

    // Preview
    const reader = new FileReader();
    reader.onloadend = () => setFilePreview(reader.result);
    reader.readAsDataURL(file);

    // Automatically upload after selecting
    handleApiCall(file);
  };

  const handleRemoveImage = () => {
    setFilePreview(null);
    setSelectedFile(null);
    setUploadedImageUrl('');
  };
  return (
    <>
      <section className="page-header">
        <div className="page-header__bg"></div>
        <div className="container d-flex justify-content-center">
          <h2 className="page-header__title bw-split-in-left">{t("My Profile")}</h2>
        </div>
      </section>
      <div className="container my-4">
        <div className="row justify-content-center">
          <div className="col-lg-10">

            <div className="card shadow-lg border-0 p-4 " style={{ borderRadius: "16px" }}>
              <div className="row overflow-auto" >

                {/* LEFT SIDE = UPLOAD SECTION */}
                <div className="col-md-12 justify-content-center mb-3">
                  {/* <label className="form-label fw-semibold">
                    Add Image <span className="text-danger">*</span>
                  </label> */}

                  {/* Circle Container */}
                  <div className="position-relative mx-auto"
                    style={{
                      width: "180px",
                      height: "180px",
                      borderRadius: "50%",
                      border: "2px dashed #ccc",
                      overflow: "hidden",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer"
                    }}>

                    {/* If Preview Exists */}
                    {filePreview ? (
                      <>
                        {/* Remove Button */}
                        <button
                          onClick={handleRemoveImage}
                          className="position-absolute btn p-0"
                          style={{
                            top: "15px",
                            right: "30px",
                            background: "white",
                            borderRadius: "50%",
                            width: "28px",
                            height: "28px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            border: "1px solid #ccc"
                          }}
                        >
                          <i className="bi bi-x-lg"></i>
                        </button>

                        {/* Preview Image */}
                        <img
                          src={filePreview}
                          alt="preview"
                          className="w-100 h-100"
                          style={{
                            objectFit: "cover"
                          }}
                        />
                      </>
                    ) : (
                      /* Upload Icon & Label */
                      <label htmlFor="custom-AppImg" className="text-center">
                        <i className="bi bi-camera-fill fs-1 text-secondary"></i>
                        <p className="m-0 text-centre small">Upload Profile Image</p>
                      </label>
                    )}

                    {/* Hidden Input */}
                    <input
                      id="custom-AppImg"
                      type="file"
                      accept="image/jpeg, image/png"
                      className="d-none"
                      onChange={handleImageChange}
                    />
                  </div>

                  {/* File Instructions / Error Messages */}
                  {sizeError ? (
                    <span className="text-danger small d-block mt-1">{sizeError}</span>
                  ) : !selectedFile ? (
                    <span className="text-muted text-center small d-block mt-1">
                      Supported: .jpg, .jpeg, .png up to 2MB.
                    </span>
                  ) : null}

                  {error && !selectedFile && (
                    <span className="text-danger small d-block mt-1 text-center">{ERROR_MESSAGES}</span>
                  )}
                </div>


                {/* RIGHT SIDE = INPUT FIELDS */}
                <div className="col-md-12">

                  <div className="row g-3">  {/* ONE SINGLE ROW – ALL FIELDS INSIDE */}

                    {/* Full Name */}
                    <div className="col-md-4">
                      <label className="form-label fw-semibold">Full Name
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="custom-form-control rounded-3"
                        placeholder="Enter Full Name"
                        value={agreementObj.USER_NAME}
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/^\s+/, "");
                          if (value.length > 0) {
                            value = value.charAt(0).toUpperCase() + value.slice(1);
                          }
                          setAgreementObj({ ...agreementObj, USER_NAME: value })
                        }
                        }
                      />
                      {error && !agreementObj.USER_NAME && (
                        <span className="text-danger small d-block mt-1">{ERROR_MESSAGES}</span>
                      )}
                    </div>

                    {/* Mobile Number */}
                    <div className="col-md-4">
                      <label className="form-label fw-semibold">Mobile Number  <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        maxLength={10}
                        className="custom-form-control rounded-3"
                        placeholder="Enter Mobile Number"
                        value={agreementObj.MOBILE_NUMBER}
                        onChange={(e) => {
                          let formatted = e.target.value.replace(/[^0-9]/g, "");
                          formatted = formatted.replace(/^[0-5]/, "");
                          setAgreementObj({ ...agreementObj, MOBILE_NUMBER: formatted });
                        }}
                      />
                      {error && !agreementObj.MOBILE_NUMBER && (
                        <span className="text-danger small d-block mt-1">{ERROR_MESSAGES}</span>
                      )}
                    </div>

                    {/* DOB */}
                    <div className="col-md-4">
                      <label className="form-label fw-semibold">Date of Birth  <span className="text-danger">*</span></label>

                      <DatePicker
                        value={agreementObj?.DOB || null}
                        onChange={handleDateChange}
                        format="dd/MM/yyyy"
                        placeholder="dd/MM/yyyy"

                        clearIcon={null}
                        defaultActiveStartDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))} // :point_left: Opens 18 years back
                        maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))}

                        className="custom-date-picker w-100"

                        dayPlaceholder={t("DD")}
                        monthPlaceholder={t("MM")}
                        yearPlaceholder={t("YYYY")}
                      />
                      {error && !agreementObj.DOB && (
                        <span className="text-danger small d-block mt-1">{ERROR_MESSAGES}</span>
                      )}
                    </div>

                    {/* Email */}
                    <div className="col-md-4">
                      <label className="form-label fw-semibold">Email  <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="custom-form-control rounded-3"
                        placeholder="Enter Email ID"
                        value={agreementObj.email}
                        onChange={(e) =>
                          setAgreementObj({
                            ...agreementObj,
                            email: e.target.value.trimStart().toLowerCase(),
                          })
                        }
                      />
                      {error && !agreementObj.email && (
                        <span className="text-danger small d-block mt-1">{ERROR_MESSAGES}</span>
                      )}
                    </div>

                    {/* Zodiac Sign */}
                    <div className="col-md-4">
                      <label className="form-label fw-semibold">Zodiac Sign  <span className="text-danger">*</span></label>
                      <Select
                        styles={customSelectStyles}
                        options={birthSigns}
                        placeholder={t("Select Sign")}
                        value={birthSigns.find((option) => option.value === agreementObj.ZODIAC_SIGN)}
                        onChange={(selectedOption) =>
                          setAgreementObj((prev) => ({
                            ...prev,
                            ZODIAC_SIGN: selectedOption.value,
                          }))
                        }
                      />
                      {error && !agreementObj.ZODIAC_SIGN && (
                        <span className="text-danger small d-block mt-1">{ERROR_MESSAGES}</span>
                      )}
                    </div>



                    {/* Birth Time */}
                    <div className="col-md-4">
                      <label className="form-label fw-semibold">Birth Time  <span className="text-danger">*</span></label>
                      <input
                        type="time"
                        className="custom-form-control rounded-3"
                        value={agreementObj.BIRTH_TIME}
                        onChange={(e) =>
                          setAgreementObj({ ...agreementObj, BIRTH_TIME: e.target.value })
                        }
                      />
                      {error && !agreementObj.BIRTH_TIME && (
                        <span className="text-danger small d-block mt-1">{ERROR_MESSAGES}</span>
                      )}
                    </div>

                    {/* Birth Place */}
                    <div className="col-md-4">
                      <label className="form-label fw-semibold">Birth Place  <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="custom-form-control rounded-3"
                        placeholder="Enter Birth Place"
                        value={agreementObj.BIRTH_PLACE}
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/^\s+/, "");
                          if (value.length > 0) {
                            value = value.charAt(0).toUpperCase() + value.slice(1);
                          }
                          setAgreementObj({ ...agreementObj, BIRTH_PLACE: value })
                        }
                        }
                      />
                      {error && !agreementObj.BIRTH_PLACE && (
                        <span className="text-danger small d-block mt-1">{ERROR_MESSAGES}</span>
                      )}
                    </div>

                    {/* Gender */}
                    <div className="col-md-4">
                      <label className="form-label fw-semibold">Gender  <span className="text-danger">*</span></label>
                      <div className="d-flex gap-3 mt-2">
                        <div>
                          <input
                            type="radio"
                            id="male"
                            name="gender"
                            value="1"
                            checked={agreementObj.GENDER === 1}
                            onChange={(e) =>
                              setAgreementObj({ ...agreementObj, GENDER: Number(e.target.value) })
                            }
                          />
                          <label htmlFor="male" className="ms-2">Male</label>
                        </div>

                        <div>
                          <input
                            type="radio"
                            id="female"
                            name="gender"
                            value="2"
                            checked={agreementObj.GENDER === 2}
                            onChange={(e) =>
                              setAgreementObj({ ...agreementObj, GENDER: Number(e.target.value) })
                            }
                          />
                          <label htmlFor="female" className="ms-2">Female</label>
                        </div>
                      </div>
                      {error && !agreementObj.GENDER && (
                        <span className="text-danger small d-block mt-1">{ERROR_MESSAGES}</span>
                      )}
                    </div>

                    {/* Address */}
                    <div className="col-4">
                      <label className="form-label fw-semibold">Address  <span className="text-danger">*</span></label>
                      <textarea
                        rows="3"
                        className="custom-form-control rounded-3"
                        placeholder="Enter address"
                        value={agreementObj.ADDRESS}
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/^\s+/, "");
                          if (value.length > 0) {
                            value = value.charAt(0).toUpperCase() + value.slice(1);
                          }
                          setAgreementObj({ ...agreementObj, ADDRESS: value })
                        }
                        }
                      ></textarea>
                      {error && !agreementObj.ADDRESS && (
                        <span className="text-danger small d-block mt-1">{ERROR_MESSAGES}</span>
                      )}
                    </div>

                    {/* Submit Button */}
                    <div className="col-12 text-center mt-2 mb-2">
                      <button
                        className="btn text-white px-4 py-2"
                        style={{
                          backgroundColor: "#a52444",
                          fontWeight: "600",
                          width: "150px",
                        }}
                        onClick={AddUpdateCustomerBtnClick}
                      >
                        Submit
                      </button>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      <ErrorMassagePupUp show={showErrorModal} onHide={() => setShowErrorModal(false)} Massage={errorMessage} />

    </>
  );
};

export default MyProfile;
